import { DiscountTypeEnum } from "../enums";

// Mirrors the backend's calculatePercentageDiscount (src/Utils/discount.utils.ts):
// percentage is clamped to 0-100 and the result is rounded at cent precision
// so the client-side grand total matches the server calculation exactly.
export const calculatePercentageDiscount = (baseAmount, percentage) => {
  const clamped = Math.min(100, Math.max(0, percentage || 0));
  return Math.round((baseAmount || 0) * clamped) / 100;
};

// Resolve the global discount in rupiah from the raw user input.
// `discountType` is the backend AMOUNT_TYPE enum (DiscountTypeEnum).
export const resolveGlobalDiscount = (subtotal, discountType, discountInput) =>
  discountType === DiscountTypeEnum.PERCENTAGE
    ? calculatePercentageDiscount(subtotal, discountInput)
    : discountInput || 0;

// Single source of truth for document header totals. Derives every dependent
// value in one pass from the raw inputs so callers never store `discount`,
// `taxAmount` or `grandTotal` as form state (which required fragile cascading
// effects and caused edit-form ordering races). Used for both live display and
// building the submit payload, guaranteeing they always agree with each other
// and with the backend calculation.
export const computeOrderTotals = ({
  subtotal = 0,
  discountType,
  discountInput = 0,
  taxable = false,
  totalIncludesTax = false,
  taxPercentage = 0,
  additionalCharges = 0,
}) => {
  const discount = resolveGlobalDiscount(subtotal, discountType, discountInput);

  let taxAmount = 0;
  let grandTotal = subtotal - discount;

  if (taxable) {
    if (totalIncludesTax) {
      taxAmount = Math.round(
        (grandTotal * taxPercentage) / (100 + taxPercentage)
      );
    } else {
      taxAmount = Math.round((grandTotal * taxPercentage) / 100);
      grandTotal += taxAmount; // Tax is added on top
    }
  }

  grandTotal += additionalCharges;

  return { discount, taxAmount, grandTotal };
};
